/* This file is autogenerated, see readme.md for instructions */
import EventSvgIcon from '@bloomreach/banana-theme/icons/event.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EventIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EventSvgIcon />
    </Icon>
  );
});

EventIcon.displayName = 'EventIcon';

export default EventIcon;
